import { render, staticRenderFns } from "./AllMerchantsSidebar.vue?vue&type=template&id=dcd1b812&scoped=true"
import script from "./AllMerchantsSidebar.vue?vue&type=script&lang=js"
export * from "./AllMerchantsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AllMerchantsSidebar.vue?vue&type=style&index=0&id=dcd1b812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd1b812",
  null
  
)

export default component.exports